import i18next from 'i18next';

import { enTranslation } from '~/src/locales/en';
import { jaTranslation } from '~/src/locales/ja';
import { TKey } from '~/src/dash/publicaUI';

const languageToTranslationMap: Record<string, Record<string, string>> = {
  en: enTranslation.translation,
  ja: jaTranslation.translation,
};

export const doesTKeyExistInTranslation = (tKey: TKey, language: string): boolean => {
  const translations = languageToTranslationMap[language];
  if (!translations) {
    return false;
  }
  return Boolean(Object.prototype.hasOwnProperty.call(translations, tKey));
};

export const isLanguageOversized = (language: string): boolean => {
  // Check if the language is one of the oversized languages
  return ['zh', 'ja', 'ko'].includes(language);
};

export const isOversizedLanguageWithTranslation = (tKey: TKey, language: string): boolean => {
  if (!language || !tKey || !isLanguageOversized(language)) {
    return false;
  }
  return doesTKeyExistInTranslation(tKey, language);
};

// IMPORTANT! only to be used in class components
export const ct = (tKey: TKey, tProps?: Record<string, string | number>): string => {
  return i18next.t(tKey, tProps || {});
};
